import { AdminHttpClient } from "@/app/api/AdminHttpClient"
import { API_PREFIX_WEBSITE_PATH } from "@/constants/prefix-path-api"
import { t } from "@/languages/i18n"
import { message } from "antd"

interface WebsiteApiItem {
  id?: number
  attributes?: {
    domain?: string
    name?: string
  }
}

export interface RoleWebsiteOption {
  id: number
  domain: string
  name: string
  label: string
}

const websiteQueryParams = {
  "pagination[pageSize]": "1000",
  sort: "createdAt:asc",
  publicationState: "preview",
  "fields[0]": "domain",
  "fields[1]": "name",
}

const mapRoleWebsites = (response: any): RoleWebsiteOption[] => {
  const websiteItems = Array.isArray(response?.data) ? (response.data as WebsiteApiItem[]) : []

  return websiteItems
    .map(item => {
      const id = Number(item?.id)
      const domain = item?.attributes?.domain?.trim?.() || ""
      const name = item?.attributes?.name?.trim?.() || ""

      return {
        id,
        domain,
        name,
        label: domain || name,
      }
    })
    .filter(item => Number.isInteger(item.id) && item.id > 0 && Boolean(item.label))
}

export const fetchRoleWebsiteOptions = async (): Promise<RoleWebsiteOption[]> => {
  try {
    const response = await AdminHttpClient.get(API_PREFIX_WEBSITE_PATH, {
      params: websiteQueryParams,
      // Role editor must list ALL websites so an admin can assign a role to
      // several sites — opt out of the per-site domain filter interceptor.
      skipDomainFilter: true,
    })

    return mapRoleWebsites(response)
  } catch (error) {
    console.error("FETCH_ROLE_WEBSITES_ERROR:", error)
    message.error(t("Failed to load domain options."))
    return []
  }
}

